import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IRequestState from './types/IRequestState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const request: Module<IRequestState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    header: {
      title: '',
      description: '',
      image: '',
    },
    form: {
      title: '',
      description: '',
      fields: {
        countries: [],
        packageTypes: [],
      },
    },
  },
  actions,
  getters,
  mutations,
};

export default request;
